import QuestionAuditTimeline from "@/components/Questions/QuestionAuditTimeline"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/questions/$questionId/history")({
  component: QuestionHistoryPage,
})

function QuestionHistoryPage() {
  const { questionId } = Route.useParams()
  return <QuestionAuditTimeline questionId={questionId} />
}
